module.exports = __webpack_public_path__ + "static/media/retrato-color.d6182069.svg";